export default __webpack_public_path__ + "static/media/InvitationIcon.569dd690.svg";